import React, { useContext, useState, useEffect } from "react";
import Header from "../components/header";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import OrgContext from "../organisation/OrgContext";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { faker } from "@faker-js/faker";
import jwtInterceptor from "../components/shared/jwtInterceptor";
import Swal from "sweetalert2";
import { baseURL, host } from "../services/api";
import MobileScreen from "../assets/images/mobile/screens/screen1.png";
import AuthContext from "../components/shared/AuthContext";
import Select from "react-select";
import axios from "axios";
import { motion } from "framer-motion";
import {toast, ToastContainer} from "react-toastify"; // Import Framer Motion

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

function Dashboard() {
  const [paidRevenue, setPaidRevenue] = useState([]);
  const [notPaidRevenue, setNotPaidRevenue] = useState([]);
  const [paidRevenueCarteBancaire, setPaidRevenueCarteBancaire] = useState([]);
  const [paidRevenueCheque, setPaidRevenuecheque] = useState([]);
  const [paidRevenueEffect, setPaidRevenueEffect] = useState([]);
  const [paidRevenuePrelevement, setPaidRevenuePrevelement] = useState([]);
  const [paidRevenueVirement, setPaidRevenueVirement] = useState([]);
  const [paidRevenueCaisse, setPaidRevenueCaisse] = useState([]);

  const [payementAccountsB, setPayementAccountsBq] = useState([]);
  const [payementAccountsC, setPayementAccountsCs] = useState([]);
  const [payementAccount, setPayementAccount] = useState("0");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // client
  const [paidRevClt, setPaidRevClt] = useState([]);
  const [notPaidRevClt, setNotPaidRevClt] = useState([]);
  const [paidRevCarteClt, setPaidRevCarteClt] = useState([]);
  const [paidRevChequeClt, setPaidRevChequeClt] = useState([]);
  const [paidRevEffectClt, setPaidRevEffectClt] = useState([]);
  const [paidRevPrelevementClt, setPaidRevPrelevementClt] = useState([]);
  const [paidRevVirementClt, setPaidRevVirementClt] = useState([]);
  const [paidRevCaisseClt, setPaidRevCaisseClt] = useState([]);
  const [client, setClient] = useState([]);
  const [clients, setClients] = useState([]);

  const [paidDepense, setPaidDepense] = useState([]);
  const [notPaidDepense, setNotPaidDepense] = useState([]);
  const [paidDepenseCarteBancaire, setPaidDepenseCarteBancaire] = useState([]);
  const [paidDepenseCheque, setPaidDepensecheque] = useState([]);
  const [paidDepenseEffect, setPaidDepenseEffect] = useState([]);
  const [paidDepensePrelevement, setPaidDepensePrevelement] = useState([]);
  const [paidDepenseCaisse, setPaidDepenseCaisse] = useState([]);
  const [paidDepenseVirement, setPaidDepenseVirement] = useState([]);

  // Fournisseur
  const [paidDepFor, setPaidDepFor] = useState([]);
  const [notPaidDepFor, setNotPaidDepFor] = useState([]);
  const [paidDepCarteFor, setPaidDepCarteFor] = useState([]);
  const [paidDepChequeFor, setPaidDepChequeFor] = useState([]);
  const [paidDepEffectFor, setPaidDepEffectFor] = useState([]);
  const [paidDepPrelevementFor, setPaidDepPrelevementFor] = useState([]);
  const [paidDepVirementFor, setPaidDepVirementFor] = useState([]);
  const [paidDepCaisseFor, setPaidDepCaisseFor] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const [t] = useTranslation();
  const { organisation } = useContext(OrgContext);
  const { user } = useContext(AuthContext);

  const labels = [
    t("Janvier"),
    t("Février"),
    t("Mars"),
    t("Avril"),
    t("Mai"),
    t("Juin"),
    t("Juillet"),
    t("Août"),
    t("Septembre"),
    t("Octobre"),
    t("Novembre"),
    t("Décembre"),
  ];

 
  useEffect(() => {
    console.log("im here");
    fetchSousAccountsBq();
    fetchSousCompteCs();
    getFournisseur();
    getClient();
    getReceivable();
    getPayables();
    getFlux();
    getDraftData();
  }, []);

  useEffect(() => {
    if (payementAccount !== "0") {
      getFlux();
    }
  }, [payementAccount]);

  useEffect(()=>{
    getReceivable();
    getPayables();
    getFlux();
    getTresorieCaisse();
    getTresorieBq();
  },[selectedYear])


  // Animation variants
  const blockVariants = {
    hidden: { opacity: 0, y: 50 }, // Initial state (invisible and shifted down)
    visible: { opacity: 1, y: 0 }, // Final state (visible and in place)
  };

  const staticData = [
    // Revenus
    {
      label: t("Revenue Payé Total"),
      data: paidRevenue,
      backgroundColor: "#4A235A", // Violet Foncé
    },
    {
      label: t("Revenue Payé par Carte Bancaire"),
      data: paidRevenueCarteBancaire,
      backgroundColor: "#6C3483", // Violet
    },
    {
      label: t("Revenue Payé par Chéque"),
      data: paidRevenueCheque,
      backgroundColor: "#8E44AD", // Violet Moyen
    },
    {
      label: t("Revenue Payé par Prélèvement"),
      data: paidRevenuePrelevement,
      backgroundColor: "#993499", // Violet Clair
    },
    {
      label: t("Revenue Payé par Effet"),
      data: paidRevenueEffect,
      backgroundColor: "#d478d0", // Lavande
    },
    {
      label: t("Revenue Payé par Virement"),
      data: paidRevenueVirement,
      backgroundColor: "#D2B4DE", // Lavande Très Clair
    },
    {
      label: t("Revenue Payé par Caisse"),
      data: paidRevenueCaisse,
      backgroundColor: "#E8DAEF", // Violet Très Clair
    },
    // Dépenses
    {
      label: t("Dépense Payé Total"),
      data: paidDepense,
      backgroundColor: "#da5000", // Jaune Vif
    },
    {
      label: t("Dépense Payé par Carte Bancaire"),
      data: paidDepenseCarteBancaire,
      backgroundColor: "#ff6d0c", // Jaune Clair
    },
    {
      label: t("Dépense Payé par Chéque"),
      data: paidDepenseCheque,
      backgroundColor: "#f7b148", // Jaune Orangé
    },
    {
      label: t("Dépense Payé par Prélèvement"),
      data: paidDepensePrelevement,
      backgroundColor: "#dda919", // Jaune Doré
    },
    {
      label: t("Dépense Payé par Effet"),
      data: paidDepenseEffect,
      backgroundColor: "#ffbb00", // Jaune Très Clair
    },
    {
      label: t("Dépense Payé par Virement"),
      data: paidDepenseVirement,
      backgroundColor: "#FAD02E", // Jaune Soleil
    },
    {
      label: t("Dépense Payé par Caisse"),
      data: paidDepenseCaisse,
      backgroundColor: "#F7DC6F", // Jaune Clair Pâle
    },
  ];

  ////////// filtrage
  const [paymentType, setPaymentType] = useState("0");
  const [payementBanqueOption, setPayementBanqueOption] = useState("0");

  const fetchSousAccountsBq = async () => {
    await jwtInterceptor
      .get("/data/user/bq/accounts/" + organisation.id)
      .then((res) => {
        setPayementAccountsBq(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchSousCompteCs = async () => {
    await jwtInterceptor
      .get("/data/user/cs/accounts/" + organisation.id)
      .then((res) => {
        setPayementAccountsCs(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  console.log("payement accounts bq", payementAccountsB);
  const [datafiltrer, setDataFiltrer] = useState([]);
  const dataN = {
    labels,
    datasets: datafiltrer.length !== 0 ? datafiltrer : staticData,
  };
  const filtrer = () => {
    if (paymentType === "caisse") {
      setDataFiltrer([
        {
          label: t("Revenue Payé Total"),
          data: paidRevenue,
          backgroundColor: "#4A235A", // Violet Foncé
        },
        {
          label: t("Revenue Payé par Caisse"),
          data: paidRevenueCaisse,
          backgroundColor: "#E8DAEF", // Violet Très Clair
        },
        {
          label: t("Dépense Payé Total"),
          data: paidDepense,
          backgroundColor: "#da5000", // Jaune Vif
        },
        {
          label: t("Dépense Payé par Caisse"),
          data: paidDepenseCaisse,
          backgroundColor: "#F7DC6F", // Jaune Clair Pâle
        },
      ]);
    } else {
      switch (payementBanqueOption) {
        case "cb":
          setDataFiltrer([
            {
              label: t("Revenue Payé Total"),
              data: paidRevenue,
              backgroundColor: "#4A235A", // Violet Foncé
            },
            {
              label: t("Revenue Payé par Carte Bancaire"),
              data: paidRevenueCarteBancaire,
              backgroundColor: "#6C3483", // Violet
            },
            {
              label: t("Dépense Payé Total"),
              data: paidDepense,
              backgroundColor: "#da5000", // Jaune Vif
            },
            {
              label: t("Dépense Payé par Carte Bancaire"),
              data: paidDepenseCarteBancaire,
              backgroundColor: "#ff6d0c", // Jaune Clair
            },
          ]);
          break;

        case "ch":
          setDataFiltrer([
            {
              label: t("Revenue Payé Total"),
              data: paidRevenue,
              backgroundColor: "#4A235A", // Violet Foncé
            },
            {
              label: t("Revenue Payé par Chéque"),
              data: paidRevenueCheque,
              backgroundColor: "#8E44AD", // Violet Moyen
            },
            {
              label: t("Dépense Payé Total"),
              data: paidDepense,
              backgroundColor: "#da5000", // Jaune Vif
            },
            {
              label: t("Dépense Payé par Chéque"),
              data: paidDepenseCheque,
              backgroundColor: "#f7b148", // Jaune Orangé
            },
          ]);
          break;

        case "v":
          setDataFiltrer([
            {
              label: t("Revenue Payé Total"),
              data: paidRevenue,
              backgroundColor: "#4A235A", // Violet Foncé
            },
            {
              label: t("Revenue Payé par Virement"),
              data: paidRevenueVirement,
              backgroundColor: "#D2B4DE", // Lavande Très Clair
            },
            {
              label: t("Dépense Payé Total"),
              data: paidDepense,
              backgroundColor: "#da5000", // Jaune Vif
            },
            {
              label: t("Dépense Payé par Virement"),
              data: paidDepenseVirement,
              backgroundColor: "#FAD02E", // Jaune Soleil
            },
          ]);
          break;

        case "p":
          setDataFiltrer([
            {
              label: t("Revenue Payé Total"),
              data: paidRevenue,
              backgroundColor: "#4A235A", // Violet Foncé
            },
            {
              label: t("Revenue Payé par Prélèvement"),
              data: paidRevenuePrelevement,
              backgroundColor: "#993499", // Violet Clair
            },
            {
              label: t("Dépense Payé Total"),
              data: paidDepense,
              backgroundColor: "#da5000", // Jaune Vif
            },
            {
              label: t("Dépense Payé par Prélèvement"),
              data: paidDepensePrelevement,
              backgroundColor: "#dda919", // Jaune Doré
            },
          ]);
          break;

        case "e":
          setDataFiltrer([
            {
              label: t("Revenue Payé Total"),
              data: paidRevenue,
              backgroundColor: "#4A235A", // Violet Foncé
            },
            {
              label: t("Revenue Payé par Effet"),
              data: paidRevenueEffect,
              backgroundColor: "#d478d0", // Lavande
            },
            {
              label: t("Dépense Payé Total"),
              data: paidDepense,
              backgroundColor: "#da5000", // Jaune Vif
            },
            {
              label: t("Dépense Payé par Effet"),
              data: paidDepenseEffect,
              backgroundColor: "#ffbb00", // Jaune Très Clair
            },
          ]);
          break;

        default:
          setDataFiltrer(staticData);
      }
    }
    window.$("#staticBackdrop").modal("hide");
  };

  const optionsN = {
    responsive: true,
    plugins: {
      legend: { position: "bottom" },
      title: { display: true, text: "" },
    },
  };

  const [paidReceivables, setPaidReceivables] = useState(0);
  const [notPaidReceivables, setNotPaidReceivables] = useState(0);
  const [allReceivables, setAllReceivables] = useState(0);

  const [paidPayables, setPaidPayables] = useState(0);
  const [notPaidPayables, setNotPaidPayables] = useState(0);
  const [allPayables, setAllPayables] = useState(0);

  const [valueReceivable, setValueReceivable] = useState(0);
  const [valuePayable, setValuePayable] = useState(0);

  const [valueRevenuClient, setValueRevenuClient] = useState(0);
  const [valueDEpenseFor, setValueDepenseFor] = useState(0);

  const [revenuPayeClient, setrevenuPayeClient] = useState();
  const [revenuNonPayeClient, setrevenuNonPayeClient] = useState();

  const [depensePayeFor, setDepensePayeFor] = useState(0);
  const [depenseNonPayeFor, setDepenseNonPayeFor] = useState(0);

  const [totalCaisse,setTotalCaisse] = useState(0);
  const [totalBq,setTotalBq] = useState(0);

  const [valueTresorie, setValueTresorie] = useState(0);

  const getTresorieCaisse = async () => {
    try {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/getTresorieCaisse/${organisation.id}/${selectedYear}`
      );

      if (data ) {
        console.log('rs3 mode', data.data.totalCaisse);
        setTotalCaisse(data.data.totalCaisse);
      }
    } catch (error) {
      console.error("Error retrieving caisse", error);
    }
  }

  const getTresorieBq = async () => {
    try {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/getTresorieBq/${organisation.id}/${selectedYear}`
      );

      if (data ) {
        console.log('rs3 mode', data.data.totalBq);
        setTotalBq(data.data.totalBq);
      }
    } catch (error) {
      console.error("Error retrieving caisse", error);
    }
  }

  const getReceivable = async () => {
    try {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/recevable/${organisation.id}/${selectedYear}`
      );

      if (data && data.data) {
        setValueReceivable(data.data.paid ?? []);
        setPaidReceivables(data.data.paid ?? []);
        setNotPaidReceivables(data.data.not_paid ?? []);
        setAllReceivables(data.data.all ?? []);
      }
    } catch (error) {
      console.error("Error retrieving receivables", error);
    }
  };
// document 
const [valueDraft,setValueDraft] = useState(0);
const [drafts, setDrafts] = useState({nombreDraftInvProccesed: 0, 
  nombreDraftRlvProccesed: 0, 
  nombreDraftInvInproccesed: 0, 
  nombreDraftRlvInproccesed: 0});
  const [isLoadingDrafts, setIsLoadingDrafts] = useState(true);

  const getDraftData = async () => {
    try {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/draftData/${organisation.id}`
      );
      console.log("drafts data", data);
      if (data && data.data) {
        setDrafts(data.data);
      }
    } catch (error) {
      console.error("Error retrieving draft data", error);
    } finally {
      setIsLoadingDrafts(false);
    }
  }

  useEffect(() => {
    getDraftData();
  }, []);

  useEffect(() => {
    if(valueTresorie<0){
      toast.warning(t("Le solde actuel est négatif. Veuillez vérifier les mouvements concernés et procéder à une régularisation si nécessaire."), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  }, [valueTresorie]);

  const getFlux = async () => {
    try {
      const url =
        payementAccount != "0"
          ? `${baseURL}/data/rapports/flux/${organisation.id}/${selectedYear}/${payementAccount}`
          : `${baseURL}/data/rapports/flux/${organisation.id}/${selectedYear}`;

      const { data } = await jwtInterceptor.get(url);

      setPaidRevenue(data.data.paid_revenue);
      setNotPaidRevenue(data.data.not_paid_revenue);
      setPaidRevenueCarteBancaire(data.data.paid_revenue_carte_bancaire);
      setPaidRevenueEffect(data.data.paid_revenue_effect);
      setPaidRevenuePrevelement(data.data.paid_revenue_prelevement);
      setPaidRevenueVirement(data.data.paid_revenue_virement);
      setPaidRevenuecheque(data.data.paid_revenue_cheque);
      setPaidRevenueCaisse(data.data.paid_revenue_caisse);

      setPaidDepense(data.data.paid_depense);
      setNotPaidDepense(data.data.not_paid_depense);
      setPaidDepenseCarteBancaire(data.data.paid_depense_carte_bancaire);
      setPaidDepensePrevelement(data.data.paid_depense_prelevement);
      setPaidDepenseEffect(data.data.paid_depense_effect);
      setPaidDepenseVirement(data.data.paid_depense_virement);
      setPaidDepensecheque(data.data.paid_depense_cheque);
      setPaidDepenseCaisse(data.data.paid_depense_caisse);

      console.log("data from flux ", data);
    } catch (error) {
      console.error("Error retrieving flux", error);
    }
  };

  const transformArrayToOptions = (target) => {
    let array = [];
    for (let i = 0; i < target.length; i++) {
      let obj = { value: target[i].id, label: target[i].companyName };
      array.push(obj);
    }
    return array;
  };

  /////////clients
  const [dataClt, setDataClt] = useState({
    labels,
    datasets: [
      {
        label: t("Revenue Payé Total"),
        data: [],
        backgroundColor: "#4A235A", // Violet Foncé
      },
      {
        label: t("Revenue Payé par Carte Bancaire"),
        data: [],
        backgroundColor: "#6C3483", // Violet
      },
      {
        label: t("Revenue Payé par Chéque"),
        data: [],
        backgroundColor: "#8E44AD", // Violet Moyen
      },
      {
        label: t("Revenue Payé par Prélèvement"),
        data: [],
        backgroundColor: "#993499", // Violet Clair
      },
      {
        label: t("Revenue Payé par Effet"),
        data: [],
        backgroundColor: "#d478d0", // Lavande
      },
      {
        label: t("Revenue Payé par Virement"),
        data: [],
        backgroundColor: "#D2B4DE", // Lavande Très Clair
      },
      {
        label: t("Revenue Payé par Caisse"),
        data: [],
        backgroundColor: "#E8DAEF", // Violet Très Clair
      },
    ],
  });
  ///
  const getFluxClientBloc = async ()=>{
    try {
      if (client.value){ 
      setPaidRevClt(0);
      setNotPaidRevClt(0);
      console.log("here we go ",paidRevClt,notPaidRevClt);
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/fluxClientBloc/${client.value}/${selectedYear}`
      );
      console.log("flux Client", data);
      setPaidRevClt(data.data.paidRevenu);
      setNotPaidRevClt(data.data.notPaidRevenu)
      setValueRevenuClient(data.data.paidRevenu);
    }
    } catch (error) {
        console.error("Error retrieving flux client", error);
      }
  }
  ///
  useEffect(() => {
    if (client.value) {
      const getFluxClient = async () => {
        try {
          const { data } = await jwtInterceptor.get(
            `${baseURL}/data/rapports/fluxClient/${client.value}/${selectedYear}`
          );
          console.log("flux Client", data);
          setDataClt({
            labels,
            datasets: [
              {
                label: t("Revenue Payé Total"),
                data: data.data.paid_revenue,
                backgroundColor: "#4A235A", // Violet Foncé
              },
              {
                label: t("Revenue Payé par Carte Bancaire"),
                data: data.data.paid_revenue_carte_bancaire,
                backgroundColor: "#6C3483", // Violet
              },
              {
                label: t("Revenue Payé par Chéque"),
                data: data.data.paid_revenue_cheque,
                backgroundColor: "#8E44AD", // Violet Moyen
              },
              {
                label: t("Revenue Payé par Prélèvement"),
                data: data.data.paid_revenue_prelevement,
                backgroundColor: "#993499", // Violet Clair
              },
              {
                label: t("Revenue Payé par Effet"),
                data: data.data.paid_revenue_effect,
                backgroundColor: "#d478d0", // Lavande
              },
              {
                label: t("Revenue Payé par Virement"),
                data: data.data.paid_revenue_virement,
                backgroundColor: "#D2B4DE", // Lavande Très Clair
              },
              {
                label: t("Revenue Payé par Caisse"),
                data: data.data.paid_revenue_caisse,
                backgroundColor: "#E8DAEF", // Violet Très Clair
              },
            ],
          });

        } catch (error) {
          console.error("Error retrieving flux client", error);
        }
      };
      getFluxClientBloc();
      getFluxClient();
    }
  }, [client,selectedYear]);

  //////////fournisseur
  const [dataFour, setDataFour] = useState({
    labels,
    datasets: [
      {
        label: t("Dépense Payé Total"),
        data: [],
        backgroundColor: "#da5000", // Jaune Vif
      },
      {
        label: t("Dépense Payé par Carte Bancaire"),
        data: [],
        backgroundColor: "#ff6d0c", // Jaune Clair
      },
      {
        label: t("Dépense Payé par Chéque"),
        data: [],
        backgroundColor: "#f7b148", // Jaune Orangé
      },
      {
        label: t("Dépense Payé par Prélèvement"),
        data: [],
        backgroundColor: "#dda919", // Jaune Doré
      },
      {
        label: t("Dépense Payé par Effet"),
        data: [],
        backgroundColor: "#ffbb00", // Jaune Très Clair
      },
      {
        label: t("Dépense Payé par Virement"),
        data: [],
        backgroundColor: "#FAD02E", // Jaune Soleil
      },
      {
        label: t("Dépense Payé par Caisse"),
        data: [],
        backgroundColor: "#F7DC6F", // Jaune Clair Pâle
      },
    ],
  });

  const getFournisseur = async () => {
    try {
      const response3 = await axios.get(
        `${baseURL}/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`
      );
      console.log("data ", response3.data.data);
      const transformedSuppliers = transformArrayToOptions(response3.data.data);
      setSuppliers(transformedSuppliers);
    } catch (error) {
      console.log("error while retrieving products by user: " + error);
    }
  };

  const getClient = async () => {
    try {
      const response2 = await axios.get(
        `${baseURL}/client/getbyuser/${user.id}/client/${organisation.id}`
      );
      console.log("data clients : ", response2.data.data);
      const transformedSuppliers = transformArrayToOptions(response2.data.data);
      setClients(transformedSuppliers);
    } catch (error) {}
  };

  const getFluxFournisseurBloc = async () => {
    try {
      if (supplier.value) {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/fluxFournisseurBloc/${parseInt(
          supplier.value
        )}/${selectedYear}`
      );
      setDepensePayeFor(data.data.paidDepense);
      setDepenseNonPayeFor(data.data.notPaidDepense);
      setValueDepenseFor(data.data.paidDepense)
    }
    } catch (error) {
      console.error("Error retrieving flux fournisseur", error);
    }
  };
  // Fetch data when supplier changes
  useEffect(() => {
    if (supplier.value) {
      const getFluxFournisseur = async () => {
        try {
          const { data } = await jwtInterceptor.get(
            `${baseURL}/data/rapports/fluxFournisseur/${parseInt(
              supplier.value
            )}/${selectedYear}`
          );

          // Update state with the fetched data
          setPaidDepFor(data.data.paid_depense);
          setPaidDepCarteFor(data.data.paid_depense_carte_bancaire);
          setPaidDepPrelevementFor(data.data.paid_depense_prelevement);
          setPaidDepEffectFor(data.data.paid_depense_effect);
          setPaidDepVirementFor(data.data.paid_depense_virement);
          setPaidDepChequeFor(data.data.paid_depense_cheque);
          setPaidDepCaisseFor(data.data.paid_depense_caisse);

          // Update chart data after fetching the new data
          setDataFour({
            labels,
            datasets: [
              {
                label: t("Dépense Payé Total"),
                data: data.data.paid_depense,
                backgroundColor: "#da5000", // Jaune Vif
              },
              {
                label: t("Dépense Payé par Carte Bancaire"),
                data: data.data.paid_depense_carte_bancaire,
                backgroundColor: "#ff6d0c", // Jaune Clair
              },
              {
                label: t("Dépense Payé par Chéque"),
                data: data.data.paid_depense_cheque,
                backgroundColor: "#f7b148", // Jaune Orangé
              },
              {
                label: t("Dépense Payé par Prélèvement"),
                data: data.data.paid_depense_prelevement,
                backgroundColor: "#dda919", // Jaune Doré
              },
              {
                label: t("Dépense Payé par Effet"),
                data: data.data.paid_depense_effect,
                backgroundColor: "#ffbb00", // Jaune Très Clair
              },
              {
                label: t("Dépense Payé par Virement"),
                data: data.data.paid_depense_virement,
                backgroundColor: "#FAD02E", // Jaune Soleil
              },
              {
                label: t("Dépense Payé par Caisse"),
                data: data.data.paid_depense_caisse,
                backgroundColor: "#F7DC6F", // Jaune Clair Pâle
              },
            ],
          });
        } catch (error) {
          console.error("Error retrieving flux fournisseur", error);
        }
      };

      getFluxFournisseurBloc();
      getFluxFournisseur();
    }
  }, [supplier,selectedYear]);

  const getPayables = async () => {
    try {
      const { data } = await jwtInterceptor.get(
        `${baseURL}/data/rapports/payable/${organisation.id}/${selectedYear}`
      );
      setValuePayable(data.data.paid);
      setPaidPayables(data.data.paid);
      setNotPaidPayables(data.data.not_paid);
      setAllPayables(data.data.all);
    } catch (error) {
      console.error("Error retrieving payables", error);
    }
  };
  console.log("data ", dataN);

  const [years, setYears] = useState([]);
    // Générer la liste d'années
    useEffect(() => {
      const currentYear = new Date().getFullYear();
      const startYear = 2000;
      const yearList = [];
      
      for (let year = currentYear; year >= startYear; year--) {
        yearList.push(year);
      }
      
      setYears(yearList);
    }, []);
  
    // Gérer la sélection de l'année
    const handleYearChange = (e) => {
      setSelectedYear(e.target.value);
      console.log("Année sélectionnée :", e.target.value);
      
    };

  return (
    <>
      <ToastContainer />

        <div>
          <div
            class="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="staticBackdropLabel">
                    {t("Filtrer votre graphique de trésorerie")}
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1" className="">
                      {t("Mode de règlement")}*
                    </label>
                    <select
                      className="form-select"
                      id="buyPriceAccountInput"
                      onChange={(e) => setPaymentType(e.target.value)}
                      value={paymentType}
                    >
                      <option value="0">
                        {t('Sélectionner un mode de règlement')}
                      </option>
                      <option value="banque">{t('Banques')}</option>
                      <option value="caisse">{t('Caisses')}</option>
                    </select>
                  </div>
                  {paymentType === "banque" && (
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        {t("Sous Compte*")}
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => {
                          setPayementAccount(e.target.value);
                          getFlux();
                        }}
                        value={payementAccount}
                      >
                        <option value="0">{t('sélectionner un sous compte')}</option>
                        {payementAccountsB.map((pA) => (
                          <option key={pA.id} value={pA.id}>
                            {pA.code + " - " + pA.name}
                          </option>
                        ))}
                      </select>

                      <label htmlFor="exampleInputEmail1" className="">
                        {t("option de paiement bancaire")}*
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) =>
                          setPayementBanqueOption(e.target.value)
                        }
                        value={payementBanqueOption}
                      >
                        <option value="0">
                          {t("Sélectionner option de paiement bancaire")}
                        </option>
                        <option value="cb">{t('Carte bancaire')}</option>
                        <option value="e">{t('Effet')}</option>
                        <option value="p">{t('Prélèvement')}</option>
                        <option value="ch">{t('Chéque')}</option>
                        <option value="v">{t('Virement')}</option>
                      </select>
                    </div>
                  )}
                  {paymentType === "caisse" && (
                    <div className="form-group">
                      <label htmlFor="exampleInputEmail1" className="">
                        {t("Sous Compte*")}
                      </label>
                      <select
                        className="form-select"
                        id="buyPriceAccountInput"
                        onChange={(e) => setPayementAccount(e.target.value)}
                        value={payementAccount}
                      >
                        <option value="0">{t('sélectionner un sous compte')}</option>
                        {payementAccountsC.map((pA) => (
                          <option key={pA.id} value={pA.id}>
                            {pA.code + " - " + pA.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setPayementAccount("0");
                      getFlux();
                      setDataFiltrer(staticData);
                      window.$("#staticBackdrop").modal("hide");
                    }}
                  >
                    {t("Afficher tout")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => filtrer()}
                  >
                    {t("Enregistrer")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      <motion.div
        className="row"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.7 }} // Delay between animations
      >
      <div className="row" style={{display:"flex",justifyContent:'space-between'}}>
        <div className="col-md-3 animation-hover">
          <p className="card" style={{ padding: 20 }}>
            <CorporateFareOutlinedIcon /> {t("Bonjour")}{" "}
            {user?.name &&
              `${user.name.charAt(0).toUpperCase()}${user.name.slice(1)}`}{" "}
            {user?.nick_name &&
              `${user.nick_name.charAt(0).toUpperCase()}${user.nick_name.slice(
                1
              )}`}
            <br />
            {organisation?.name || ""}
          </p>
        </div>
        <div  className="col-md-4 animation-hover">
              <div className="card" style={{ padding: 20 }}>
              <label htmlFor="year-select">{t('Sélectionnez une année')} </label>
      <select id="year-select" className="form-select" onChange={handleYearChange}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
              </div>
        </div>
      </div>
      </motion.div>

      <motion.div
        className="row"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.7 }} // Delay between animations
      >
      <div className="row">
      <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h6>{t("Tresories")}</h6>
                  <h2 className="mb-0 number-font">
                    {Number(valueTresorie).toFixed(2)}{" "}
                    <span>{organisation?.currency?.code}</span>
                  </h2>
                </div>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-receivable-section"
                    className="custom-switch-input"
                    checked={valueTresorie === totalCaisse}
                    onChange={() => setValueTresorie(totalCaisse)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Caisses")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-receivable-section"
                    className="custom-switch-input"
                    checked={valueTresorie === totalBq}
                    onChange={() => setValueTresorie(totalBq)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Banques")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h6>{t("Chiffre d'affaires")}</h6>
                  <h2 className="mb-0 number-font">
                    {Number(valueReceivable).toFixed(2)}{" "}
                    <span>{organisation?.currency?.code}</span>
                  </h2>
                </div>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-receivable-section"
                    className="custom-switch-input"
                    checked={valueReceivable === notPaidReceivables}
                    onChange={() => setValueReceivable(notPaidReceivables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures impayées")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-receivable-section"
                    className="custom-switch-input"
                    checked={valueReceivable === paidReceivables}
                    onChange={() => setValueReceivable(paidReceivables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures payées")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-receivable-section"
                    className="custom-switch-input"
                    checked={valueReceivable === allReceivables}
                    onChange={() => setValueReceivable(allReceivables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures payées et impayées")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h6>{t("Total Achats")}</h6>
                  <h2 className="mb-0 number-font">
                    {Number(valuePayable).toFixed(2)}{" "}
                    {organisation?.currency?.code}
                  </h2>
                </div>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-payable-section"
                    className="custom-switch-input"
                    checked={valuePayable === notPaidPayables}
                    onChange={() => setValuePayable(notPaidPayables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures impayées")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-payable-section"
                    className="custom-switch-input"
                    checked={valuePayable === paidPayables}
                    onChange={() => setValuePayable(paidPayables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures payées")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-payable-section"
                    className="custom-switch-input"
                    checked={valuePayable === allPayables}
                    onChange={() => setValuePayable(allPayables)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Factures payées et impayées")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {!isLoadingDrafts && (
          <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
  <div className="card overflow-hidden">
    <div className="card-body">
      <div className="d-flex">
        <div className="mt-2">
          <h6>{t("Rapport Document")}</h6>
          <h2 className="mb-0 number-font">
            {valueDraft}
          </h2>
        </div>
      </div>
      <div className="form-group">
        <label className="custom-switch form-switch">
          <input
            type="radio"
            name="custom-switch-radio-draft-section"
            className="custom-switch-input"
            value={drafts?.nombreDraftInvProccesed || 0}
            checked={valueDraft == drafts?.nombreDraftInvProccesed}
            onChange={(e) => setValueDraft(e.target.value || 0)}
          />
          <span className="custom-switch-indicator"></span>
          <span className="custom-switch-description">
            {t("Factures Processees")}
          </span>
        </label>
      </div>
      <div className="form-group">
        <label className="custom-switch form-switch">
          <input
            type="radio"
            name="custom-switch-radio-draft-section"
            className="custom-switch-input"
            checked={valueDraft == drafts?.nombreDraftRlvProccesed}
            value={drafts?.nombreDraftRlvProccesed || 0}
            onChange={(e) => setValueDraft(e.target.value || 0)}
          />
          <span className="custom-switch-indicator"></span>
          <span className="custom-switch-description">
            {t("Relevés Processees")}
          </span>
        </label>
      </div>
      <div className="form-group">
        <label className="custom-switch form-switch">
          <input
            type="radio"
            name="custom-switch-radio-draft-section"
            className="custom-switch-input"
            value={drafts?.nombreDraftInvInproccesed || 0}
            checked={valueDraft == drafts?.nombreDraftInvInproccesed}
            onChange={(e) => setValueDraft(e.target.value || 0)}
          />
          <span className="custom-switch-indicator"></span>
          <span className="custom-switch-description">
            {t("Factures Non Processees")}
          </span>
        </label>
      </div>
      <div className="form-group">
        <label className="custom-switch form-switch">
          <input
            type="radio"
            name="custom-switch-radio-draft-section"
            className="custom-switch-input"
            value={drafts?.nombreDraftRlvInproccesed || 0}
            checked={valueDraft == drafts?.nombreDraftRlvInproccesed}
            onChange={(e) => setValueDraft(e.target.value || 0)}
          />
          <span className="custom-switch-indicator"></span>
          <span className="custom-switch-description">
            {t("Relevés Non Processees")}
          </span>
        </label>
      </div>
    </div>
  </div>
</div>
        )}
        {/* //// les Clients  */}
        <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h6>{t("Mouvement Client")}</h6>
                  <h2 className="mb-0 number-font">
                    {Number(valueRevenuClient).toFixed(2)}{" "}
                    <span>{organisation?.currency?.code}</span>
                  </h2>
                </div>
              </div>
              <div className="form-group">
                <Select
                  value={client}
                  options={clients}
                  onChange={(choice) => setClient(choice)}
                />
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-recClient-section"
                    className="custom-switch-input"
                    checked={valueRevenuClient === paidRevClt}
                    onChange={() => setValueRevenuClient(paidRevClt)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Revenu payés")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-recClient-section"
                    className="custom-switch-input"
                    checked={valueRevenuClient === notPaidRevClt}
                    onChange={() => setValueRevenuClient(notPaidRevClt)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Revenu Non Payé")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* //// les fournisseurs */}
        <div className="col-lg-4 col-md-4 col-sm-12 col-xl-4 animation-hover">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h6>{t("Mouvement Fournisseur")}</h6>
                  <h2 className="mb-0 number-font">
                    {Number(valueDEpenseFor).toFixed(2)}{" "}
                    <span>{organisation?.currency?.code}</span>
                  </h2>
                </div>
              </div>
              <div className="form-group">
                <Select
                  value={supplier}
                  options={suppliers}
                  onChange={(choice) => setSupplier(choice)}
                />
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-recFor-section"
                    className="custom-switch-input"
                    checked={valueDEpenseFor === depensePayeFor}
                    onChange={() => setValueDepenseFor(depensePayeFor)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Dépense payés")}
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label className="custom-switch form-switch">
                  <input
                    type="radio"
                    name="custom-switch-radio-recFor-section"
                    className="custom-switch-input"
                    checked={valueDEpenseFor === depenseNonPayeFor}
                    onChange={() => setValueDepenseFor(depenseNonPayeFor)}
                  />
                  <span className="custom-switch-indicator"></span>
                  <span className="custom-switch-description">
                    {t("Dépense Non Payé")}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* 
        <div className="col-lg-6 col-md-6 col-sm-12 col-xl-3">
          <div className="card overflow-hidden">
            <div className="card-body">
              <div className="d-flex">
                <div className="mt-2">
                  <h4 className="mb-0 number-font">{t("ELManager Mobile")}</h4>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  width={120}
                  height={120}
                  src={`${host}/apk/qrcode/elmanager-mobile.png`}
                />
                <img src={MobileScreen} height={162} />
              </div>
            </div>
          </div>
        </div> */}
      </div>
      </motion.div>

      <motion.div
        className="row"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.7 }} // Delay between animations
      >
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            
            <div className="card-header">
              <div className="card-title">{t("Flux de Trésorerie")}</div>
              <div class="mt-4 mb-4 mx-4 text-right animation-hover">
                <a
                  className="btn btn-primary"
                  onClick={() => {
                    window.$("#staticBackdrop").modal("show");
                  }}
                >
                  {t("Filtrer à nouveaux")}
                </a>
              </div>
            </div>
            <div className="card-body">
              <Bar options={optionsN} data={dataN} />
            </div>
          </div>
        </div>
      </div>
      </motion.div>
      <motion.div
        className="row"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.7 }} // Delay between animations
      >
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                {t("Situation de Trésorerie des Fournisseurs")}
              </div>
            </div>
            <br />
            <div className='class="mt-4 mb-4 mx-4 text-right'>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="">
                  {t("Choisir le fournisseur")}*
                </label>
                <Select
                  value={supplier}
                  options={suppliers}
                  onChange={(choice) => setSupplier(choice)}
                />
              </div>
              <div className="card-body">
                <Bar options={optionsN} data={dataFour} />
              </div>
            </div>
          </div>
        </div>
      </div>
      </motion.div>
      <motion.div
        className="row"
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.7 }} // Delay between animations
      >
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                {t("Situation de Trésorerie des Clients")}
              </div>
            </div>
            <br />
            <div className='class="mt-4 mb-4 mx-4 text-right'>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1" className="">
                  {t('Choisir le Client')}*
                </label>
                <Select
                  value={client}
                  options={clients}
                  onChange={(choice) => setClient(choice)}
                />
              </div>
              <div className="card-body">
                <Bar options={optionsN} data={dataClt} />
              </div>
            </div>
          </div>
        </div>
      </div>
      </motion.div>
    </>
  );
}

export default connect(null)(Dashboard);
